module.exports = __webpack_public_path__ + "img/img4.797e3415.svg";